/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */

import React, { useEffect, useState } from "react";
import "../../assets/css/print.css";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import notifications from "../../assets/json/notifications";
import message from "../../assets/json/message";
import {
  Applogo,
  Avatar_02,
  headerlogo,
  lnEnglish,
  lnArabic,
  lnHebrew,
  lnFrench,
  lnGerman,
  lnSpanish,
} from "../../Routes/ImagePath";

import { FaRegBell, FaRegComment } from "react-icons/fa";
import { useLocation } from "react-router-dom/dist";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import { BsCalculator } from "react-icons/bs";
import MassBCalculator from "../../components/massb-calculator/MassBCalc";
import { MdOutlineStickyNote2 } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import useAuthentication from "../../hooks/useAuthentication";

const Header = (props) => {
  const currentUser = useSelector((state) => state.user).value;
  const authData = useSelector((state) => state.user).auth;
  const { signout, getCurrentUser } = useAuthentication();
  const companyData = useSelector((state) => state.ahid)?.iniFile?.headerList;
  const data = notifications.notifications;
  const datas = message.message;
  const [notification, setNotifications] = useState(false);
  const [flag, setflag] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [profile, setProfile] = useState(false);
  const [flagImage, setFlagImage] = useState(lnEnglish);

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };
  const onMenuClik = () => {
    document.body.classList.toggle("slide-nav");
  };

  const themes = localStorage.getItem("theme");

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setNotifications(false);
    setProfile(false);
    setflag(false);
  };

  // const handleFlags = () => {
  //   setflag(!flag);
  //   setIsOpen(false);
  //   setNotifications(false);
  //   setProfile(false);
  // };
  const handleNotification = () => {
    setNotifications(!notification);
    setflag(false);
    setIsOpen(false);
    setProfile(false);
  };
  const handleProfile = () => {
    setProfile(!profile);
    setNotifications(false);
    setflag(false);
    setIsOpen(false);
  };

  const location = useLocation();
  let pathname = location.pathname;
  // const { value } = useSelector((state) => state.user);
  const Credencial = localStorage.getItem("credencial");
  const Value = JSON.parse(Credencial);
  const UserName = Value?.email?.split("@")[0];
  const user = useSelector((state) => state.user).value;
  const ProfileName = user?.displayName;
  // console.log(user);
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    console.log("Changing language to", lng); // Debugging statement
    i18n.changeLanguage(lng);
    setFlagImage(
      lng === "en"
        ? lnEnglish
        : lng === "ar"
        ? lnArabic
        : lng === "he"
        ? lnHebrew
        : lnGerman
    );
  };

  // Calculator
  const [showCalc, setshowCalc] = useState(false);
  const handleCloseCalc = () => setshowCalc(false);
  const handleShowCalc = () => setshowCalc(true);

  useEffect(() => {
    getCurrentUser();
  }, []);

  return (
    <div className="header hide-on-print" style={{ right: "0px" }}>
      <Modal
        id="wrapper"
        show={showCalc}
        onHide={handleCloseCalc}
        className="calcM"
        dialogClassName="modal-calc"
      >
        <Modal.Body id="appp" className="modal-calc " dir="ltr">
          <MassBCalculator />
          {/* <ReactCalculator className="calc-react" /> */}
        </Modal.Body>
      </Modal>
      {/* Logo */}
      <div className="header-left">
        <Link to="/ft-intro" className="logo">
          <img src={headerlogo} width={40} height={40} alt="img" />
        </Link>
        <Link to="#" className="logo2">
          <img src={Applogo} width={40} height={40} alt="img" />
        </Link>
      </div>
      {/* <div className="header-left">
        <Link to="/admin-dashboard" className="logo">
          <img src={headerlogo} width={40} height={40} alt="img" />
        </Link>
        <Link to="/admin-dashboard" className="logo2">
          <img src={Applogo} width={40} height={40} alt="img" />
        </Link>
      </div> */}
      {/* /Logo */}
      <Link
        id="toggle_btn"
        to="#"
        style={{
          display: pathname.includes("tasks")
            ? "none"
            : pathname.includes("compose")
            ? "none"
            : "",
        }}
        onClick={handlesidebar}
      >
        <span className="bar-icon">
          <span />
          <span />
          <span />
        </span>
      </Link>
      {/* Header Title */}
      <div className="page-title-box">
        <h3>FinTrack Light</h3>
      </div>
      {/* /Header Title */}
      <Link
        id="mobile_btn"
        className="mobile_btn"
        to="#"
        onClick={() => onMenuClik()}
      >
        <i className="fa fa-bars" />
      </Link>

      {companyData ? (
        <>
          <div className="page-title-box">
            <h3>{companyData.businessName}</h3>
          </div>
          {companyData.taxYear ? (
            <div className="page-title-box">
              <span>السنة المالية: </span>
              <span>{companyData.taxYear}</span>
            </div>
          ) : (
            <div className="page-title-box">
              <span>الفترة المالية: </span>
              <span>{`${companyData.dataPeriodStartDate
                .toString()
                .substring(0, 4)} - ${companyData.dataPeriodEndDate
                .toString()
                .substring(0, 4)}`}</span>
            </div>
          )}
        </>
      ) : (
        <div className="page-title-box">
          <Link to="/open-format">
            <h3>تحميل البيانات</h3>
          </Link>
        </div>
      )}

      {/* Header Menu */}
      <ul className="nav user-menu">
        {/* Search */}
        <li className="nav-item">
          <div className="top-nav-search">
            <Link to="#" className="responsive-search">
              <i className="fa fa-search" />
            </Link>
            <form>
              <input
                className="form-control"
                type="text"
                placeholder="بحث, رقم هوية  "
              />
              <button className="btn" type="submit">
                <i className="fa fa-search" />
              </button>
            </form>
          </div>
        </li>
        {/* /Search */}
        {/* Flag */}

        <li className="nav-item dropdown has-arrow flag-nav ">
          <Link
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            to="#"
            role="button"
          >
            <img src={flagImage} alt="Flag" height="20" />
            {t(i18n.language)}
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              to="#"
              className="dropdown-item"
              onClick={() => changeLanguage("en")}
            >
              <img src={lnEnglish} alt="Flag" height="16" /> En
            </Link>
            <Link
              to="#"
              className="dropdown-item"
              onClick={() => changeLanguage("ar")}
            >
              <img src={lnArabic} alt="Flag" height="16" />
              Ar
            </Link>
            <Link
              to="#"
              className="dropdown-item"
              onClick={() => changeLanguage("he")}
            >
              <img src={lnHebrew} alt="Flag" height="16" />
              He
            </Link>
            {/* <Link
              to="#"
              className="dropdown-item"
              onClick={() => changeLanguage("fr")}>
              <img src={lnFrench} alt="Flag" height="16" /> French
            </Link>
            <Link
              to="#"
              className="dropdown-item"
              onClick={() => changeLanguage("es")}>
              <img src={lnSpanish} alt="Flag" height="16" /> Spanish
            </Link>
            <Link
              to="#"
              className="dropdown-item"
              onClick={() => changeLanguage("de")}>
              <img src={lnGerman} alt="Flag" height="16" /> German
            </Link> */}
          </div>
        </li>
        {/* /Flag */}
        {/* Notifications */}
        {/* <li className="nav-item dropdown">
          <Link
            to="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            onClick={handleNotification}>
            <i>
              <FaRegBell />
            </i>{" "}
            <span className="badge badge-pill">3</span>
          </Link>
          <div
            className={`dropdown-menu dropdown-menu-end notifications ${
              notification ? "show" : ""
            }`}>
            <div className="topnav-dropdown-header">
              <span className="notification-title">Notifications</span>
              <Link
                to="#"
                onClick={() => setNotifications(false)}
                className="clear-noti">
                {" "}
                Clear All{" "}
              </Link>
            </div>
            <div className="noti-content">
              <ul className="notification-list">
                {data.map((val, index) => {
                  return (
                    <li className="notification-message" key={index}>
                      <Link
                        onClick={() =>
                          localStorage.setItem("minheight", "true")
                        }
                        to="/app/administrator/activities">
                        <div className="media d-flex">
                          <span className="avatar flex-shrink-0">
                            <img alt="" src={val.image} />
                          </span>
                          <div className="media-body">
                            <p className="noti-details">
                              <span className="noti-title">{val.name}</span>{" "}
                              {val.contents}{" "}
                              <span className="noti-title">
                                {val.contents_2}
                              </span>
                            </p>
                            <p className="noti-time">
                              <span className="notification-time">
                                {val.time}
                              </span>
                            </p>
                          </div>
                        </div>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="topnav-dropdown-footer">
              <Link
                onClick={() => localStorage.setItem("minheight", "true")}
                to="/app/administrator/activities">
                View all Notifications
              </Link>
            </div>
          </div>
        </li> */}
        {/* /Notifications */}
        {/* Message Notifications */}
        {/* <li className={`nav-item dropdown ${isOpen ? "show" : ""}`}>
          <Link
            to="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            onClick={toggleDropdown}>
            <i>
              <FaRegComment />
            </i>{" "}
            <span className="badge badge-pill">8</span>
          </Link>
          <div
            className={`dropdown-menu dropdown-menu-end notifications ${
              isOpen ? "show" : ""
            }`}>
            <div className="topnav-dropdown-header">
              <span className="notification-title">Messages</span>
              <Link to="#" className="clear-noti">
                {" "}
                Clear All{" "}
              </Link>
            </div>
            <div className="noti-content">
              <ul className="notification-list">
                {datas.map((value, index) => {
                  return (
                    <li className="notification-message" key={index}>
                      <Link
                        onClick={() =>
                          localStorage.setItem("minheight", "true")
                        }
                        to="/conversation/chat">
                        <div className="list-item">
                          <div className="list-left">
                            <span className="avatar">
                              <img alt="" src={value.image} />
                            </span>
                          </div>
                          <div className="list-body">
                            <span className="message-author">{value.name}</span>
                            <span className="message-time">{value.time}</span>
                            <div className="clearfix" />
                            <span className="message-content">
                              {value.contents}
                            </span>
                          </div>
                        </div>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="topnav-dropdown-footer">
              <Link
                onClick={() => localStorage.setItem("minheight", "true")}
                to="/conversation/chat">
                View all Messages
              </Link>
            </div>
          </div>
        </li> */}
        {/* /Message Notifications */}
        <li>
          <Link
            // className="dropdown-item "
            to="#"
            role="button"
            onClick={handleShowCalc}
          >
            <BsCalculator size={20} className="" />{" "}
            {/* <span> MassP_Calculator</span> */}
          </Link>
        </li>
        {/* Sticky Note */}
        <li className={`nav-item dropdown ${isOpen ? "show" : ""}`}>
          <Link
            to="/stickynote"
            // className="dropdown-toggle nav-link"
            // data-bs-toggle="dropdown"
            // onClick={toggleDropdown}
          >
            <MdOutlineStickyNote2 size={25} className="" />
            {/* <i
              className="fa fa-sticky-note text-primary"
              // data-bs-toggle="tooltip"
              // title="fa fa-sticky-note"
            /> */}
            {/* <span className="badge badge-pill">8</span> */}
          </Link>
          {/* <div
            className={`dropdown-menu dropdown-menu-end notifications ${
              isOpen ? "show" : ""
            }`}>
            <div className="topnav-dropdown-header">
              <span className="notification-title">Messages</span>
              <Link to="#" className="clear-noti">
                {" "}
                Clear All{" "}
              </Link>
            </div>
            <div className="noti-content">
              <ul className="notification-list">
                {datas.map((value, index) => {
                  return (
                    <li className="notification-message" key={index}>
                      <Link
                        onClick={() =>
                          localStorage.setItem("minheight", "true")
                        }
                        to="/conversation/chat">
                        <div className="list-item">
                          <div className="list-left">
                            <span className="avatar">
                              <img alt="" src={value.image} />
                            </span>
                          </div>
                          <div className="list-body">
                            <span className="message-author">{value.name}</span>
                            <span className="message-time">{value.time}</span>
                            <div className="clearfix" />
                            <span className="message-content">
                              {value.contents}
                            </span>
                          </div>
                        </div>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="topnav-dropdown-footer">
              <Link
                onClick={() => localStorage.setItem("minheight", "true")}
                to="/conversation/chat">
                View all Messages
              </Link>
            </div>
          </div> */}
        </li>
        {/* /Sticky Note */}
        {currentUser ? (
          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
              to="#"
              onClick={handleProfile}
            >
              {" "}
              <span className="user-img me-1">
                <img src={authData.photoURL || Avatar_02} alt="img" />
                <span className="status online" />
              </span>
              <span>{ProfileName ? `${ProfileName}` : " Admin "}</span>
            </Link>
            <div
              className={`dropdown-menu dropdown-menu-end ${
                profile ? "show" : ""
              }`}
            >
              <Link className="dropdown-item" to="/profile">
                حسابي الشخصي
              </Link>
              <Link className="dropdown-item" to="/settings/companysetting">
                الإعدادات
              </Link>
              <Link className="dropdown-item" to="#" onClick={signout}>
                تسجيل الخروج
              </Link>
            </div>
          </li>
        ) : (
          <li className="nav-item dropdown has-arrow main-drop">
            <Link className="dropdown-item" to="/">
              تسجيل الدخول
            </Link>
          </li>
        )}
        {/* <li className="nav-item dropdown has-arrow main-drop">
          <Link
            to="#"
            className="dropdown-toggle nav-link"
            data-bs-toggle="dropdown"
            onClick={handleProfile}
          >
            {" "}
            <span className="user-img me-1">
              <img src={Avatar_02} alt="img" />
              <span className="status online" />
            </span>
            <span>{ProfileName ? `${ProfileName}` : " Admin "}</span>
          </Link>
          <div
            className={`dropdown-menu dropdown-menu-end ${
              profile ? "show" : ""
            }`}
          >
            <Link className="dropdown-item" to="/profile">
              My Profile
            </Link>
            <Link className="dropdown-item" to="/settings/companysetting">
              Settings
            </Link>
            <Link className="dropdown-item" to="/" onClick={signout}>
              Logout
            </Link>
          </div>
        </li> */}
      </ul>
      {/* /Header Menu */}

      {/* Mobile Menu */}
      {currentUser ? (
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-end dropdown-menu-right">
            <Link className="dropdown-item" to="/profile">
              My Profile
            </Link>
            <Link className="dropdown-item" to="/settings/companysetting">
              Settings
            </Link>
            <Link className="dropdown-item" to="#" onClick={signout}>
              Logout
            </Link>
          </div>
        </div>
      ) : (
        <div className="mobile-user-menu">
          <Link className="dropdown-item" to="/">
            تسجيل الدخول
          </Link>
        </div>
      )}
      {/* /Mobile Menu */}
    </div>
  );
};

export default Header;
